import axios from '../axios';

/**
 * @param options.silent Auth bootstrap'i icin. 401 alindiginda zorla cikis ve
 * login yonlendirmesi tetiklenmez; yalnizca lokal state temizlenir. Anonim her
 * sayfa yuklemesinde bu istek 401 alir ve silinecek bir cerez yoktur.
 */
export const getProfile = async (options?: { silent?: boolean }) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/profile`,
    { skipAutoCancel: true, skipForcedLogout: options?.silent }
  );
  if (response.status === 200) {
    return response.data;
  }
  return null;
};

export const updateProfile = async (data: any) => {
  const response = await axios.patch(`${process.env.REACT_APP_BASE_URL}/user/profile`, data);
  return response;
}